import React from 'react';

import styled from 'styled-components';

import Radio from 'components/lib/Radio';

import { UserManagementFeatureFlagKeyType, UserManagementFeatureFlagOptionType } from './types';

const FlagRow = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: center;
  gap: 20px;
  padding: 10px;
  border: 1px solid var(--line-gray);
  border-radius: 6px;
  background: var(--white);

  &.changed {
    border-color: var(--button-blue);
  }
`;

const FlagText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  line-height: 1.4;
`;

const FlagLabel = styled.div`
  font-family: var(--font-medium);
  font-size: 13px;
  color: var(--text-primary);
`;

const FlagOptions = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
  white-space: nowrap;
`;

type Props = {
  flag: UserManagementFeatureFlagOptionType;
  changed: boolean;
  value?: boolean;
  detail: React.ReactNode;
  dataTestIdPrefix: string;
  onChange: (key: UserManagementFeatureFlagKeyType, value: boolean) => void;
  onOptionClick?: (key: UserManagementFeatureFlagKeyType, value: boolean) => void;
};

const UserManagementFeatureFlagsModalRow = ({
  flag,
  changed,
  value,
  detail,
  dataTestIdPrefix,
  onChange,
  onOptionClick,
}: Props) => (
  <FlagRow className={changed ? 'changed' : undefined}>
    <FlagText>
      <FlagLabel>{flag.label}</FlagLabel>
      {detail}
    </FlagText>
    <Radio.Group value={value} onChange={(event: any) => onChange(flag.key, event.target.value)}>
      <FlagOptions>
        <Radio
          className="large"
          value={false}
          onClick={() => onOptionClick?.(flag.key, false)}
          data-test-id={`${dataTestIdPrefix}-${flag.key}-off`}
        >
          Off
        </Radio>
        <Radio
          className="large"
          value={true}
          onClick={() => onOptionClick?.(flag.key, true)}
          data-test-id={`${dataTestIdPrefix}-${flag.key}-on`}
        >
          On
        </Radio>
      </FlagOptions>
    </Radio.Group>
  </FlagRow>
);

export default UserManagementFeatureFlagsModalRow;
